/**
 * menu-toggle-expanded.js
 *
 * Reports open/closed state on the hamburger menu buttons (ACCA issue #9).
 *
 * snippets/push_menu.liquid and sections/toolbar_mobile.liquid render real
 * <button>s that open #t4s-menu-drawer, but nothing told assistive tech whether
 * the drawer is currently open. aria-expanded can't be hardcoded in Liquid --
 * a static "false" would be wrong the moment the drawer opens -- so it is
 * mirrored here from the drawer's own aria-hidden, which the theme already
 * toggles in global.min.js.
 */
(function () {
  'use strict';

  var DRAWER_ID = 't4s-menu-drawer';

  function wire(drawer) {
    // Scoped by aria-controls so this only ever touches triggers that really
    // point at this drawer.
    var triggers = document.querySelectorAll(
      '[aria-controls="' + DRAWER_ID + '"]'
    );
    if (!triggers.length) return;

    function sync() {
      var expanded = drawer.getAttribute('aria-hidden') === 'false';
      for (var i = 0; i < triggers.length; i++) {
        triggers[i].setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    new MutationObserver(sync).observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });

    sync();
  }

  function init() {
    // querySelectorAll, not getElementById: the theme renders this id from two
    // branches, and getElementById would silently pick only the first.
    var drawers = document.querySelectorAll('#' + DRAWER_ID);
    for (var i = 0; i < drawers.length; i++) wire(drawers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
